import { buildUrlFromLocation } from "@/utils/httpUtils";
import http from "@/services/http";

export default {
    async getAll() {
        return await http.get(buildUrlFromLocation(`/admin/orders/shipping_methods`, { campaignId: null }));
    },

    async create(orderShippingMethod) {
        return await http.post(buildUrlFromLocation(`/order-shipping-methods`, { campaignId: null }), orderShippingMethod);
    }
};



// WEBPACK FOOTER //
// ./src/services/orderShippingMethod.js